"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redact = exports.Logger = void 0;
// Browser-only entry point - no Winston dependency
const BrowserLogger_1 = require("./services/BrowserLogger");
Object.defineProperty(exports, "Logger", { enumerable: true, get: function () { return BrowserLogger_1.BrowserLogger; } });
const redact_1 = require("./services/redact");
Object.defineProperty(exports, "redact", { enumerable: true, get: function () { return redact_1.redact; } });
//# sourceMappingURL=index.browser.js.map